var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38.9744,
    rx: 8.20513,
    fill: "#4B00A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2548 27.5309V20.0526C30.2548 16.3772 29.4635 13.5697 25.1756 13.5697C23.1082 13.5697 21.73 14.6927 21.1685 15.7647H21.1174V13.9015H17.0592V27.5309H21.2961V20.7673C21.2961 18.9806 21.6279 17.2706 23.8229 17.2706C25.9924 17.2706 26.0179 19.2869 26.0179 20.8693V27.5054H30.2548V27.5309Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1679 13.9015H14.4047V27.5309H10.1679V13.9015Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2863 7.11226C10.9336 7.11226 9.83607 8.20976 9.83607 9.5625C9.83607 10.9152 10.9336 12.0383 12.2863 12.0383C13.639 12.0383 14.7365 10.9152 14.7365 9.5625C14.7365 8.20976 13.639 7.11226 12.2863 7.11226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/LinkedIn Logo.3e76af388d3af6d74976a53572a18b3a.svg";
export { ForwardRef as ReactComponent };